module.exports = __webpack_public_path__ + "1af7213e8d4388c015ce8d521dc0601e.jpg";